import { IPropQueries } from '@kurtosys/types/common/IPropQueries.js';
import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';

import { commonUtils } from '../../common/index.js';
import { Query } from '../Query.js';
import { queryHelper } from '../queryUtils/index.js';

export abstract class QueryStore {
	abstract get executionOptions(): IExecutionOptions;
	abstract initialize(): Promise<void>;
	abstract query(options?: IQueryOptions, overrideExecutionOptions?: Partial<IExecutionOptions>): any;
	mergeQueriesAndProps<T>(componentOrchestration?: IPropQueries<any, any>): T | undefined {
		if (componentOrchestration) {
			const { props, queries } = componentOrchestration;
			const dependencies = { queryClass: Query };
			const queryResults = queries
				? queryHelper.convertQueryMime(dependencies, queries, this.executionOptions)
				: {};
			const response: T = commonUtils.deepMergeObjects(props || {}, queryResults);
			return response;
		}
	}
	flattenProps: (props?: { [key: string]: any }, keysToFlatten?: string[]) => any;
}
